export default {
  sorry: 'Ursäkta',
  sorryClass: 'Vi kunde tyvärr inte hitta biljettpriser i ',
  weFound: 'hittade ',
  noResults: 'inget',
  fares: ' fares',
  theseDates: ' dessa datum.',
  matchingSearch: 'som matchade din sökning.',
}
